/* Global settings context — loads Supabase site_settings once and provides throughout the app. */
import { createContext, useContext, useEffect, useState } from 'react';
import { fetchSettings, STATIC } from './cms';

const SettingsContext = createContext(STATIC.settings);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(STATIC.settings);
  useEffect(() => { fetchSettings().then(setSettings); }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
